import { SchemaInspector, ActionPropertyDescriptor } from ".";
import { ActionComponentDescription, TableGlideType, MutatingScreenKind } from "../description";
import { ComponentHandlerBase } from "./handler";
import { makeDefaultActionDescriptor } from "./primitive";

export abstract class ActionComponentHandlerBase<T extends ActionComponentDescription> extends ComponentHandlerBase<T> {
    public getActionDescriptors(
        _desc: T | undefined,
        _table: TableGlideType | undefined,
        schema: SchemaInspector | undefined,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): readonly ActionPropertyDescriptor<T>[] {
        return [makeDefaultActionDescriptor(schema, mutatingScreenKind, false)];
    }
}
